module.exports = __webpack_public_path__ + "static/assets/ab74d03e2b99c83801e64afda6cd0663.png";